import React, { useState, useEffect } from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from "reactstrap";
import { useLocation } from "react-router-dom";

function TicketListDropDownOption(props) {
  const location = useLocation();
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    const pathMap = [
        { path: "/trouble-ticket/all-ticket-list", index: 0 },
        { path: "/proactive-ticket-list", index: 1 },
    ];
    const matched = pathMap.find(p => location.pathname.startsWith(p.path));
    setSelectedItem(matched ? matched.index : null);
}, [location.pathname]);

  return (
    <div className={props.className}>
      <UncontrolledButtonDropdown>
        <DropdownToggle caret color="link" className={`p-0 ${selectedItem !== null ? 'proactive-active-dropdown' : ''}`} >
          <div style={{ display: "inline-block"}}>
    {selectedItem !== null && props.buttons[selectedItem] 
        ? props.buttons[selectedItem].name 
        : "Ticket List"}
</div>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-right">
        {props.buttons.map((button, i) => (
          <DropdownItem
            key={i}
            active={selectedItem === i}
            onClick={() => {
              setSelectedItem(i);
              button.action();
            }}
          >
            {button.name}
          </DropdownItem>
        ))}
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    </div>
  );
}

export default TicketListDropDownOption;